import api from "./api";
import { socket } from "../socket";

export const fetchChatHistory = async (roomId) => {
  try {
    const response = await api.get(`/api/v1/chat/tms/${roomId}/messages`);
    return response.data;
  } catch (error) {
    console.error(
      "Error creating form:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const uploadingFile = async (formData, roomId) => {

  const res = await api.post(`/api/v1/chat/tms/${roomId}/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  // emit message after saving
  socket.emit("send_message", res.data.message);
};